module.exports = __webpack_public_path__ + "static/img/tipsIcode.60ed0de.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/tipsIcode.png
// module id = 0Ep1
// module chunks = 1